import { FunctionComponent, useEffect } from "react";
import IconButtonField from "../Button/IconButtonField";
import Avatars from "../Avatar/Avatars";
import Menus from "../Menu/Menu";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { clearListuser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import { useLocation, useNavigate } from "react-router-dom";
import "./MenuBar.scss";
import { listMenu } from "../../Redux/Slices/Menu/ListMenuSlice";
const MenuBar: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: menu_list } = useAppSelector((state) => state.ListMenuSlice);
  console.log("menu_list", menu_list);
  const adminMenuList = Array.isArray(menu_list?.data)
    ? menu_list?.data?.filter((val) => val.portal === "ADMIN")
    : [];
  const pathname = location.pathname.substring(1);

  const menuHading = adminMenuList?.find((val) => val.path === pathname);

  console.log("menuHading", menuHading);

  useEffect(() => {
    dispatch(listMenu());
  }, []);
  return (
    <div className="menu_main_block">
      <div className="menu_heading">{menuHading?.menuname}</div>
      {/* <div> */}
      <Menus
        menuItems={[
          {
            menu: "Logout",
            onClick: () => {
              sessionStorage.clear();
              dispatch(clearListuser());
              dispatch(clearLoginStatus());
              dispatch(clearDashboardChart());
              navigate("/login");
            },
          },
        ]}
      >
        <IconButtonField onClick={() => {}}>
          <Avatars sx={{ height: "2rem", width: "2rem" }} />
        </IconButtonField>
      </Menus>
      {/* <span className="Username">{ListUser[0]?.student_name}</span>
        </div> */}
    </div>
  );
};

export default MenuBar;
